import { ProductsApiAdapter } from '../adapters/ProductsApiAdapter';
import { ProductsModel } from '../models/Products';
import { Filters } from '../models/Filters';

export interface Page {
  products: ProductsModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: ProductsApiAdapter) {}

  async getAllMovements(): Promise<ProductsModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getProductsPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getProductsPaginated(filters);
  }

  async exportProductsExcel(filters: Filters = {}): Promise<string> {
    return this.apiAdapter.exportProductsExcel(filters);
  }

  async deleteProduct(productId: number): Promise<void> {
    return this.apiAdapter.deleteProduct(productId);
  }

  async bulkUploadProducts(file: File): Promise<{ message?: string }> {
    return this.apiAdapter.uploadProductsBulk(file);
  }
}
